export const INFO_CONTENT = {
  strengthScore: {
    title: 'Strength Score',
    content:
      'Your Strength Score is calculated from your best lifts across 5 core exercises: Bench Press, Back Squat, Deadlift, Weighted Pull-Up, and Dead Hang. Heavier lifts = higher score. It\'s how DUEL measures your overall strength.',
  },
  freshness: {
    title: 'Activity Status',
    content:
      'Your activity status shows how current your lifts are.\n\n• Up To Date — logged in the last 7 days\n• Active — logged in the last 14 days\n• Needs Update — it\'s been 14-30 days\n• Outdated — over 30 days since your last lift\n\nKeep logging to stay ranked!',
  },
  duels: {
    title: 'Duels',
    content:
      'A Duel is a head-to-head lifting challenge between you and another gym member. Pick an exercise, set a timeframe, and see who comes out on top. It\'s friendly competition to push each other harder.',
  },
  baselineLifts: {
    title: 'Your Core 5',
    content:
      'Your Core 5 are the lifts that determine your Strength Score: Bench Press, Back Squat, Deadlift, Weighted Pull-Up, and Dead Hang. Log all 5 to get your official ranking.',
  },
} as const;
